module.exports = __webpack_public_path__ + "img/zxsqurel.1d8611bb.png";